import { render } from "./Translate.vue?vue&type=template&id=56b06326&ts=true"
import script from "./Translate.vue?vue&type=script&lang=ts"
export * from "./Translate.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__